import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

import ThemeColorConstant from "constants/ThemeColorsConstant";

const solid = defineStyle({
  padding: "25px 20px",

  borderRadius: "0px",
  color: "white",
  background: "#000000",
  width: "full",
  _hover: {
    background: "#000000A0",
  },
});

const solidMini = defineStyle({
  padding: "0px 25px",

  borderRadius: "0px",
  color: "white",
  background: "#000000",

  _hover: {
    background: "#000000A0",
  },
});

const ghost = defineStyle({
  borderRadius: "0px",

  _hover: {
    background: ThemeColorConstant.hover_background,
  },
});

const outline = defineStyle({
  justifyContent: "flex-start",
  padding: "25px 20px",
  borderRadius: "0px",
  color: "black",
  // background: "white",
  width: "full",
  border: "2px solid",
  borderColor: "black",
});

const outlineMini = defineStyle({
  padding: "0px 20px",
  borderRadius: "0px",
  color: "black",
  // background: "white",

  border: "1px solid",
  borderColor: "black",
});

const link = defineStyle({
  color: "black",
});

const ChakraUIButtonStyling = defineStyleConfig({
  variants: {
    solid,
    ghost,
    outline,
    link,
    solidMini,
    outlineMini,
  },
});

export default ChakraUIButtonStyling;
